{
  "An error occurred while scheduling the call.": "An error occurred while scheduling the call.",
  "Schedule With a Weave Onboarder": "Schedule With a Weave Onboarder",
  "productOnboardingTasks": {
    "{{count}} Tasks_many": "{{count}} Tasks",
    "{{count}} Tasks_one": "{{count}} Task",
    "{{count}} Tasks_other": "{{count}} Tasks"
  }
}
